export default function getTelLink(numberString, sms = false) {
  if (typeof numberString !== "string") return null
  let digitsOnly = numberString.replace(/\D/g, "")
  if (!digitsOnly.startsWith("1")) digitsOnly = "1" + digitsOnly
  if (sms) return `sms:+${digitsOnly}`
  return `tel:+${digitsOnly}`
}
